import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["bar"]
  static values = { percentage: Number }
  
  connect() {
    // Start at 0 width, then animate to target
    this.barTarget.style.width = "0%"
    
    // Use requestAnimationFrame to ensure the initial state is rendered
    // before transitioning to the target width
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.barTarget.style.width = `${this.percentageValue}%`
      })
    })
  }
}
